import React from "react";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Skeleton from "@material-ui/lab/Skeleton";

import { generateUUID } from "@/utils/uuid";
import { DataStructure, sizeToWidth } from "components/StaticTable";
import useStyle from "@/components/StaticTable/style";

interface LoadingProps<T> {
  dataStructure: DataStructure<T>[];
  elementsParPage: number;
}

function Loading<T>({ dataStructure, elementsParPage }: LoadingProps<T>) {
  const classes = useStyle();

  return (
    <TableBody>
      {Array.from({ length: elementsParPage + 1 }).map(() => (
        <TableRow key={generateUUID()}>
          {dataStructure?.map((e) => (
            <TableCell
              key={generateUUID()}
              classes={{ root: classes.cell }}
              style={e.size ? { width: sizeToWidth[e.size] } : undefined}
            >
              <Skeleton />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
}

export default Loading;
